import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.css']
})
export class TicketsComponent implements OnInit {

  IsBusy: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
